module.exports = __webpack_public_path__ + "static/media/PaymentLink.2dfb323a.svg";